(function () {
  // Ensure _br_uid_2 exists before Discovery API calls.
  // Sync only — do not wait for BrTrk/GTM (keeps PLP fast).
  // Required for category personalization + A/B bucketing.
  // https://documentation.bloomreach.com/discovery/reference/cookie-_br_uid_2
  function ensureBrUid2() {
    var match = document.cookie.match(/(?:^|;)\s*_br_uid_2=([^;]*)/);
    if (match && match[1]) {
      try {
        return decodeURIComponent(match[1]);
      } catch (e) {
        return match[1];
      }
    }
    var uid =
      'uid=' +
      Math.round(Math.random() * 1e12) +
      ':v=11.5:ts=' +
      Date.now() +
      ':hc=1';
    var expires = new Date(Date.now() + 63072000000).toUTCString();
    document.cookie =
      '_br_uid_2=' +
      encodeURIComponent(uid) +
      '; expires=' +
      expires +
      '; path=/; SameSite=Lax';
    return uid;
  }

  window.ensureBrUid2 = ensureBrUid2;
  ensureBrUid2();

  // BrTrk remains owned by GTM to avoid duplicate page-view tracking.

  // ===========================================================================
  // window.BR — single source of truth for every Bloomreach surface.
  //
  // As of the "BR-only" rendering strategy, product cards are hydrated directly
  // from the Bloomreach Discovery response (no DigitalOcean serverless hop).
  // Every section/snippet requests an expanded `fl` field list and maps each
  // BR doc through BR.docToCard(), which returns the SAME normalized shape the
  // old serverless function returned — so existing card templates render
  // unchanged. Fields Bloomreach does not expose (a second/hover image and the
  // colour-sibling count) are simply absent, so those template branches render
  // nothing by design.
  // ===========================================================================
  var BR = (window.BR = window.BR || {});

  BR.ACCOUNT_ID = '7858';
  BR.DOMAIN_KEY = 'gerberchildrenswear';

  // Expanded field list pulled from Bloomreach for product cards. Verified
  // against the live catalog (account 7858): pid, title, url, thumb_image,
  // price (regular/compare-at), sale_price (selling), price_range ([min,max]),
  // brand (vendor). Variant/SKU data is intentionally omitted — cards never add
  // to cart directly; the Add-to-Cart button opens Quick View, which loads the
  // real Shopify product form (so variant integrity is handled by Shopify).
  //
  // image_2 (hover/second image) and sibling_count (colour-sibling count) are
  // confirmed-correct field names but were not yet populated in the live index
  // as of this writing (checked across 200+ docs, both keyword and category
  // search types) — likely still propagating on Bloomreach's side. Requesting
  // them is harmless either way: BR silently omits fields it doesn't have, so
  // docToCard()'s fallbacks below apply until the index catches up, with no
  // further deploy needed once it does.
  BR.PRODUCT_FL = 'pid,title,url,thumb_image,image_2,sibling_count,price,sale_price,price_range,brand';

  BR.getBrUid2 = function () {
    return ensureBrUid2();
  };

  // Discovery "core" search/category endpoint.
  BR.getCoreApiUrl = function () {
    return window.location.hostname.includes('gcw-dev.myshopify.com')
      ? 'https://staging-core.dxpapi.com'
      : 'https://core.dxpapi.com';
  };

  // Autosuggest endpoint (predictive search).
  BR.getSuggestApiUrl = function () {
    return window.location.hostname.includes('gcw-dev.myshopify.com')
      ? 'https://staging-suggest.dxpapi.com'
      : 'https://suggest.dxpapi.com';
  };

  // Pathways/recommendations endpoint (related products widgets).
  BR.getPathwaysApiUrl = function () {
    return window.location.hostname.includes('gcw-dev.myshopify.com')
      ? 'https://pathways-staging.dxpapi.com'
      : 'https://pathways.dxpapi.com';
  };

  // Canonical storefront origin (BR returns .myshopify.com URLs on some feeds).
  BR.getBaseUrl = function () {
    return window.location.hostname.includes('gcw-dev.myshopify.com')
      ? 'https://' + window.location.hostname
      : 'https://www.gerberchildrenswear.com';
  };

  BR.formatMoney = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  BR.fetchWithTimeout = function (url, options, timeout) {
    options = options || {};
    timeout = timeout || 8000;
    return Promise.race([
      fetch(url, options),
      new Promise(function (_, reject) {
        setTimeout(function () {
          reject(new Error('Request timeout'));
        }, timeout);
      })
    ]);
  };

  BR.fetchWithRetry = async function (url, options, retries, timeout) {
    options = options || {};
    retries = retries == null ? 2 : retries;
    timeout = timeout || 8000;
    for (var i = 0; i <= retries; i++) {
      try {
        var response = await BR.fetchWithTimeout(url, options, timeout);
        if (response.ok) return response;
        if (i < retries && (response.status >= 500 || response.status === 429)) {
          await new Promise(function (r) {
            setTimeout(r, Math.pow(2, i) * 1000);
          });
          continue;
        }
        return response;
      } catch (error) {
        if (i === retries) throw error;
        await new Promise(function (r) {
          setTimeout(r, Math.pow(2, i) * 1000);
        });
      }
    }
  };

  // Build a Discovery "core" API URL. `params` overrides/extends the defaults.
  // A param value may be an array (e.g. multiple `fq` filter clauses) — each
  // item is serialized as its own repeated `key=value` pair.
  BR.buildCoreUrl = function (params) {
    var defaults = {
      account_id: BR.ACCOUNT_ID,
      domain_key: BR.DOMAIN_KEY,
      request_type: 'search',
      fl: BR.PRODUCT_FL,
      url: window.location.href,
      ref_url: window.location.href,
      _br_uid_2: BR.getBrUid2()
    };
    var merged = Object.assign({}, defaults, params || {});
    var pairs = [];
    Object.keys(merged).forEach(function (k) {
      var v = merged[k];
      if (v == null || v === '') return;
      if (Array.isArray(v)) {
        v.forEach(function (item) {
          if (item == null || item === '') return;
          pairs.push(encodeURIComponent(k) + '=' + encodeURIComponent(item));
        });
      } else {
        pairs.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
      }
    });
    return BR.getCoreApiUrl() + '/api/v1/core/?' + pairs.join('&');
  };

  function toNum(v) {
    if (v == null) return null;
    if (Array.isArray(v)) v = v[0];
    var n = parseFloat(v);
    return isNaN(n) ? null : n;
  }

  function handleFromUrl(url) {
    if (!url) return '';
    var m = String(url).match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  // Map a raw Bloomreach product doc -> normalized card model.
  // Returns the EXACT shape the old serverless get-products returned, so every
  // existing card template consumes it without modification.
  //
  //   BR price  -> regular / compare-at price
  //   BR sale_price -> current selling price (falls back to price)
  //   BR price_range ([min,max]) -> priceRange for the "From $X" label
  BR.docToCard = function (doc) {
    if (!doc) return null;
    var pid = String(doc.pid || '');
    var regular = toNum(doc.price);
    var selling = doc.sale_price != null ? toNum(doc.sale_price) : regular;
    if (selling == null) selling = regular;
    var onSale = regular != null && selling != null && regular > selling;

    var range = Array.isArray(doc.price_range) ? doc.price_range : null;
    var minPrice = range != null ? toNum(range[0]) : selling;
    var maxPrice = range != null ? toNum(range[1]) : selling;

    var handle = handleFromUrl(doc.url);

    return {
      handle: handle,
      id: pid ? 'gid://shopify/Product/' + pid : '',
      title: doc.title || '',
      vendor: doc.brand || '',
      // Use a relative product URL — the BR feed returns .myshopify.com URLs.
      onlineStoreUrl: handle ? '/products/' + handle : doc.url || '#',
      variant: {
        price: selling != null ? String(selling) : '0',
        compareAtPrice: onSale ? String(regular) : null
      },
      priceRange: {
        minPrice: minPrice != null ? String(minPrice) : '0',
        maxPrice: maxPrice != null ? String(maxPrice) : '0'
      },
      // Second image is optional — falls back to a single-image array (no
      // hover swap) until Bloomreach actually returns image_2 for a doc.
      images: doc.thumb_image
        ? (doc.image_2 ? [doc.thumb_image, doc.image_2] : [doc.thumb_image])
        : [],
      // Falls back to null (no "+N Colors" badge) until Bloomreach returns a
      // positive sibling_count for a doc.
      siblingCount: (function () {
        var n = toNum(doc.sibling_count);
        return n != null && n > 0 ? Math.round(n) : null;
      })()
    };
  };

  // Map a batch of BR docs, preserving order and dropping malformed rows.
  BR.docsToCards = function (docs) {
    return (docs || [])
      .filter(function (d) {
        return d && d.pid;
      })
      .map(BR.docToCard);
  };

  // Rebuild the "standard" product-card price block (search / featured /
  // related / horizontal share this markup) to reflect a corrected price.
  // Used as the applyPrice callback for BR.recheckPrices. No-ops when unchanged.
  BR.applyStandardPrice = function (card, sellingCents, compareCents) {
    var priceWrap = card.querySelector('.product-card__info .f-price');
    if (!priceWrap) return;
    var regularEl = priceWrap.querySelector('.f-price__regular .f-price-item--regular');
    var curText = regularEl ? (regularEl.textContent.match(/[\d.]+/) || [0])[0] : 0;
    var curCents = Math.round(parseFloat(curText) * 100);
    var wasOnSale = priceWrap.classList.contains('f-price--on-sale');
    var onSale = compareCents > sellingCents;
    if (curCents === sellingCents && wasOnSale === onSale) return;

    var sale = sellingCents % 10 === 0;
    var clearance = sellingCents % 10 === 7;
    var pctStr =
      (window.FoxTheme && FoxTheme.variantStrings && FoxTheme.variantStrings.percentOff) ||
      '[amount]% off';

    priceWrap.className = 'f-price f-price--left' + (onSale ? ' f-price--on-sale' : '');
    priceWrap.innerHTML =
      '<div class="f-price__regular">' +
      '<span class="visually-hidden visually-hidden--inline">Regular price</span>' +
      '<span class="f-price-item f-price-item--regular' +
      (sale || clearance ? ' f-price-item--regular-sale' : '') +
      '">' + BR.formatMoney(sellingCents) + '</span></div>' +
      (onSale
        ? '<div class="f-price__sale">' +
          '<span class="visually-hidden visually-hidden--inline">Sale price</span>' +
          '<span class="f-price-item f-price-item--sale">' + BR.formatMoney(sellingCents) + '</span>' +
          '<span class="visually-hidden visually-hidden--inline">Regular price</span>' +
          '<span class="f-price-item f-price-item--regular"><s>' + BR.formatMoney(compareCents) + '</s></span>' +
          '<span class="f-price-item f-price-item--percent-off">' +
          pctStr.replace('[amount]', Math.round(((compareCents - sellingCents) / compareCents) * 100)) +
          '</span></div>'
        : '');
  };

  // ---------------------------------------------------------------------------
  // Async Shopify price re-check (visible cards only).
  //
  // The Bloomreach feed can lag Shopify, so after the grid has painted we
  // verify the first `limit` cards against Shopify's live /products/{handle}.js
  // and correct the displayed price when it differs. Runs after full load so it
  // never blocks first paint. `applyPrice(cardEl, sellingCents, compareCents)`
  // is supplied by each surface because price markup differs between templates.
  // ---------------------------------------------------------------------------
  BR.recheckPrices = async function (root, limit, applyPrice) {
    root = root || document;
    limit = limit || 8;
    if (typeof applyPrice !== 'function') return;

    var wrappers = Array.prototype.slice
      .call(
        root.querySelectorAll(
          '.product-card:not(.product-card-fallback) .product-card__wrapper[data-product-handle]'
        )
      )
      .slice(0, limit);

    for (var i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];
      var handle = wrapper.getAttribute('data-product-handle');
      if (!handle) continue;
      try {
        var res = await fetch('/products/' + handle + '.js', {
          headers: { Accept: 'application/json' }
        });
        if (!res.ok) continue;
        var p = await res.json();
        // Shopify prices are integer cents. product.price is the current price
        // of the first available variant; compare_at_price is the "was" price.
        var sellingCents = typeof p.price === 'number' ? p.price : null;
        var compareCents =
          typeof p.compare_at_price === 'number' ? p.compare_at_price : 0;
        if (sellingCents == null) continue;
        var card = wrapper.closest('.product-card');
        if (card) applyPrice(card, sellingCents, compareCents);
      } catch (e) {
        /* non-fatal: keep the BR-rendered price */
      }
    }
  };

  // HTML-escape a string for safe interpolation into markup built with
  // string concatenation (as opposed to DOM APIs).
  BR.escapeHtml = function (string) {
    var matchHtmlRegExp = /["'&<>]/;
    var str = '' + string;
    var match = matchHtmlRegExp.exec(str);
    if (!match) return str;

    var escape;
    var html = '';
    var index = 0;
    var lastIndex = 0;

    for (index = match.index; index < str.length; index++) {
      switch (str.charCodeAt(index)) {
        case 34: // "
          escape = '&quot;';
          break;
        case 38: // &
          escape = '&amp;';
          break;
        case 39: // '
          escape = '&#39;';
          break;
        case 60: // <
          escape = '&lt;';
          break;
        case 62: // >
          escape = '&gt;';
          break;
        default:
          continue;
      }
      if (lastIndex !== index) html += str.substring(lastIndex, index);
      lastIndex = index + 1;
      html += escape;
    }

    return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
  };

  // Generic debounce. Preserves `this`/arguments of the call site.
  BR.debounce = function (fn, delay) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn.apply(context, args);
      }, delay);
    };
  };

  // Build a responsive srcset for a Bloomreach/Shopify CDN image URL using the
  // "_WxH" filename-suffix size variants (200/300/368/400/500). `sizes`
  // overrides the default `sizes` attribute string when the caller's layout
  // needs different breakpoints.
  BR.generateResponsiveImages = function (imageUrl, sizes) {
    if (!imageUrl) return { src: '', srcset: '', sizes: '' };
    var baseUrl = imageUrl.replace(/(\.(jpg|jpeg|png|webp))(\?.*)?$/, '$1');
    var withSize = function (size) {
      return baseUrl.replace(/(\.(jpg|jpeg|png|webp))$/, '_' + size + 'x' + size + '$1');
    };
    return {
      src: withSize(368),
      srcset: [200, 300, 368, 400, 500].map(function (w) {
        return withSize(w) + ' ' + w + 'w';
      }).join(', '),
      sizes: sizes || '(max-width: 480px) 200px, (max-width: 768px) 300px, (max-width: 1024px) 368px, 400px'
    };
  };

  // Fetch a Shopify collection's products.json and normalize to the same card
  // shape BR.docToCard returns. Used as the degraded-mode fallback when the
  // Bloomreach Discovery API is unavailable or returns nothing for a collection.
  BR.fetchShopifyCollectionProducts = async function (handle, limit) {
    if (!handle) return [];
    var response = await BR.fetchWithRetry(
      '/collections/' + handle + '/products.json?limit=' + limit,
      {},
      1,
      5000
    );
    if (!response.ok) throw new Error('Shopify collection error: ' + response.status);
    var data = await response.json();
    return (data.products || []).map(function (p) {
      var variant = (p.variants && p.variants[0]) || {};
      return {
        handle: p.handle,
        id: 'gid://shopify/Product/' + p.id,
        title: p.title,
        vendor: p.vendor,
        onlineStoreUrl: '/products/' + p.handle,
        variant: {
          price: variant.price != null ? String(variant.price) : '0',
          compareAtPrice: variant.compare_at_price != null ? String(variant.compare_at_price) : null
        },
        images: (p.images || [])
          .map(function (img) { return typeof img === 'string' ? img : img.src; })
          .filter(Boolean),
        siblingCount: null
      };
    });
  };

  // Normalize a single Shopify /products.json product object (as returned by
  // the paginated fallback fetch) into the same card shape BR.docToCard
  // returns, including a min/max priceRange derived from all variants.
  BR.convertShopifyProductToCard = function (p) {
    var variant = (p.variants && p.variants[0]) || {};
    var variantPrices = (p.variants || [])
      .map(function (v) { return parseFloat(v.price); })
      .filter(function (x) { return !isNaN(x); });
    var minPrice = variantPrices.length ? Math.min.apply(Math, variantPrices) : parseFloat(variant.price || 0);
    var maxPrice = variantPrices.length ? Math.max.apply(Math, variantPrices) : parseFloat(variant.price || 0);
    return {
      handle: p.handle,
      id: 'gid://shopify/Product/' + p.id,
      title: p.title,
      vendor: p.vendor,
      onlineStoreUrl: '/products/' + p.handle,
      variant: {
        price: variant.price != null ? String(variant.price) : '0',
        compareAtPrice: variant.compare_at_price != null ? String(variant.compare_at_price) : null
      },
      priceRange: {
        minPrice: String(minPrice),
        maxPrice: String(maxPrice)
      },
      images: (p.images || [])
        .map(function (img) { return typeof img === 'string' ? img : img.src; })
        .filter(Boolean),
      siblingCount: null
    };
  };

  function placeholderSvg() {
    return (
      '<svg class="placeholder-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5">' +
        '<path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"/>' +
        '<path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-24.9 12.3 15.3 26.1-32.5 32.9 41.9v.3h-91.3zm91.3-67.3v56.4l-32.9-41.9-26.1 32.5-12.3-15.3-20 24.9v-56.6h91.3z"/>' +
        '<circle cx="227.7" cy="244.4" r="5.4"/>' +
      '</svg>'
    );
  }

  function safeUrl(value, fallback) {
    var url = String(value || '');
    if (!url) return fallback || '';
    try {
      var protocol = new URL(url, window.location.origin).protocol;
      return protocol === 'http:' || protocol === 'https:' ? url : fallback || '';
    } catch (e) {
      return fallback || '';
    }
  }

  // Price block used by collection/search-results/predictive-search: shows a
  // "From $X" prefix when the product's price varies across variants, and a
  // sale block with only the struck-through compare-at price (no repeated
  // current price).
  function renderRangePriceBlock(price, compareAt, sale, clearance, onSale, priceDiff, percentOff, percentOffLabel) {
    var regularClass = 'f-price-item f-price-item--regular' + (sale || clearance ? ' f-price-item--regular-sale' : '');
    var saleBlock = onSale
      ? '<div class="f-price__sale">' +
          '<span class="visually-hidden visually-hidden--inline">Sale price</span>' +
          '<span class="visually-hidden visually-hidden--inline">Regular price</span>' +
          '<span class="f-price-item f-price-item--regular">' + BR.formatMoney(compareAt) + '</span>' +
          '<span class="f-price-item f-price-item--percent-off">' + percentOffLabel.replace('[amount]', percentOff) + '</span>' +
        '</div>'
      : '';
    return (
      '<div class="f-price__regular">' +
        '<span class="' + regularClass + '">' +
          '<span class="visually-hidden visually-hidden--inline">Regular price</span>' +
          (priceDiff ? 'From ' : '') + BR.formatMoney(price) +
        '</span>' +
      '</div>' +
      '<div class="f-price f-price--left' + (onSale ? ' f-price--on-sale' : '') + '">' + saleBlock + '</div>'
    );
  }

  // Price block used by featured-collection/related-products: no price-range
  // support, and the sale block repeats the current price alongside a
  // struck-through compare-at price.
  function renderSimplePriceBlock(price, compareAt, sale, clearance, onSale, percentOff, percentOffLabel) {
    var regularClass = 'f-price-item f-price-item--regular' + (sale || clearance ? ' f-price-item--regular-sale' : '');
    var saleBlock = onSale
      ? '<div class="f-price__sale">' +
          '<span class="visually-hidden visually-hidden--inline">Sale price</span>' +
          '<span class="f-price-item f-price-item--sale">' + BR.formatMoney(price) + '</span>' +
          '<span class="visually-hidden visually-hidden--inline">Regular price</span>' +
          '<span class="f-price-item f-price-item--regular"><s>' + BR.formatMoney(compareAt) + '</s></span>' +
          '<span class="f-price-item f-price-item--percent-off">' + percentOffLabel.replace('[amount]', percentOff) + '</span>' +
        '</div>'
      : '';
    return (
      '<div class="f-price f-price--left' + (onSale ? ' f-price--on-sale' : '') + '">' +
        '<div class="f-price__regular">' +
          '<span class="visually-hidden visually-hidden--inline">Regular price</span>' +
          '<span class="' + regularClass + '">' + BR.formatMoney(price) + '</span>' +
        '</div>' +
        saleBlock +
      '</div>'
    );
  }

  // Render the shared "standard" vertical product-card markup (image,
  // flair-badges, quickview trigger, vendor, sibling-color count, title,
  // price, optional add-to-cart, quick-view-modal) used by the collection,
  // search-results, featured-collection, related-products and
  // predictive-search surfaces. `opts` captures the real differences that
  // already exist between those surfaces today — see call sites for the
  // value each one passes:
  //
  //   index                    - controls eager/high-priority loading (< 4)
  //   showAddToCart            - render the full-width add-to-cart button
  //   imageRatio               - CSS --aspect-ratio value (default '1')
  //   imageSizes               - <img sizes> override
  //   priceLayout              - 'range' (From-price aware) | 'simple'
  //   overlayColorScheme       - quick-view-modal color scheme class suffix
  //   flairBadgesLayout        - <flair-badges layout="..."> value
  //   includeTitleInAriaLabels - append ", {title}" to quickview/add-to-cart labels
  //   quickViewIdSuffix        - e.g. '-fallback' to dedupe modal ids
  //   cardClass                - extra class appended to the outer .product-card
  BR.renderProductCard = function (product, opts) {
    opts = opts || {};
    var index = opts.index || 0;
    var showAddToCart = !!opts.showAddToCart;
    var imageRatio = BR.escapeHtml(opts.imageRatio || '1');
    var imageSizes = opts.imageSizes;
    var priceLayout = opts.priceLayout || 'simple';
    var overlayColorScheme = BR.escapeHtml(opts.overlayColorScheme || 'scheme-1');
    var flairBadgesLayout = BR.escapeHtml(opts.flairBadgesLayout || 'Collection Pages Automatic');
    var includeTitleInAriaLabels = !!opts.includeTitleInAriaLabels;
    var quickViewIdSuffix = BR.escapeHtml(opts.quickViewIdSuffix || '');
    var cardClass = opts.cardClass ? ' ' + BR.escapeHtml(opts.cardClass) : '';

    var rawHandle = product.handle || '';
    var fallbackUrl = rawHandle ? '/products/' + encodeURIComponent(rawHandle) : '#';
    var handle = BR.escapeHtml(rawHandle);
    var title = BR.escapeHtml(product.title || '');
    var vendor = product.vendor ? BR.escapeHtml(product.vendor) : '';
    var onlineStoreUrl = BR.escapeHtml(safeUrl(product.onlineStoreUrl || fallbackUrl, fallbackUrl));
    var variant = product.variant || {};
    var images = product.images || [];
    var siblingCount = Number(product.siblingCount) || 0;
    var priceRange = product.priceRange;

    var productId = BR.escapeHtml(String(product.id || '').replace('gid://shopify/Product/', ''));
    var quickViewId = 'QuickView-' + productId + quickViewIdSuffix;

    var price = Math.round(parseFloat(variant.price) * 100);
    var compareAt = variant.compareAtPrice ? Math.round(parseFloat(variant.compareAtPrice) * 100) : 0;
    var sale = price % 10 === 0;
    var clearance = price % 10 === 7;
    var onSale = compareAt > price;
    var percentOffLabel = BR.escapeHtml((window.FoxTheme && FoxTheme.variantStrings && FoxTheme.variantStrings.percentOff) || '[amount]% off');
    var percentOff = onSale ? Math.round(((compareAt - price) / compareAt) * 100) : 0;

    var priceHtml;
    if (priceLayout === 'range') {
      var minPrice = priceRange ? Math.round(parseFloat(priceRange.minPrice) * 100) : price;
      var maxPrice = priceRange ? Math.round(parseFloat(priceRange.maxPrice) * 100) : price;
      priceHtml = renderRangePriceBlock(price, compareAt, sale, clearance, onSale, minPrice !== maxPrice, percentOff, percentOffLabel);
    } else {
      priceHtml = renderSimplePriceBlock(price, compareAt, sale, clearance, onSale, percentOff, percentOffLabel);
    }

    var quickViewAriaLabel = 'Quick view' + (includeTitleInAriaLabels ? ', ' + title : '');
    var addToCartAriaLabel = 'Add to cart' + (includeTitleInAriaLabels ? ', ' + title : '');

    var firstImage = BR.generateResponsiveImages(safeUrl(images[0], ''), imageSizes);
    var secondImage = BR.generateResponsiveImages(safeUrl(images[1], ''), imageSizes);
    firstImage.src = BR.escapeHtml(firstImage.src);
    firstImage.srcset = BR.escapeHtml(firstImage.srcset);
    firstImage.sizes = BR.escapeHtml(firstImage.sizes);
    secondImage.src = BR.escapeHtml(secondImage.src);
    secondImage.srcset = BR.escapeHtml(secondImage.srcset);
    secondImage.sizes = BR.escapeHtml(secondImage.sizes);

    var mainImageHtml = firstImage.src
      ? '<div class="media-wrapper product-card__image product-card__image--main" style="--aspect-ratio: ' + imageRatio + '">' +
          '<img src="' + firstImage.src + '" srcset="' + firstImage.srcset + '" sizes="' + firstImage.sizes + '" alt="' + title + '"' +
          ' loading="' + (index < 4 ? 'eager' : 'lazy') + '"' + (index < 4 ? ' fetchpriority="high"' : '') +
          ' class="motion-reduce" width="450" height="450" is="image-lazy">' +
        '</div>'
      : '<div class="product-card__image product-card__image--main" style="--aspect-ratio: ' + imageRatio + '">' + placeholderSvg() + '</div>';

    var secondImageHtml = secondImage.src
      ? '<div class="media-wrapper product-card__image product-card__image--second inset-full hidden md:block" style="--aspect-ratio: ' + imageRatio + '">' +
          '<img src="' + secondImage.src + '" srcset="' + secondImage.srcset + '" sizes="' + secondImage.sizes + '" alt="' + title + '"' +
          ' loading="lazy" class="motion-reduce" width="450" height="450" is="image-lazy">' +
        '</div>'
      : '';

    var vendorHtml = vendor
      ? '<p class="product-card__vendor text-sm-extra m-0"><span>' + vendor + '</span></p>'
      : '';

    var siblingHtml = siblingCount
      ? '<div class="product-card__colors text-sm-extra">+' + siblingCount + ' ' + (siblingCount === 1 ? 'Color' : 'Colors') + '</div>'
      : '';

    var addToCartHtml = showAddToCart
      ? '<button class="product-card__add-to-cart btn btn--primary w-full mt-2"' +
          ' aria-label="' + addToCartAriaLabel + '" aria-controls="' + quickViewId + '" aria-haspopup="dialog"' +
          ' onclick="this.closest(\'.product-card__wrapper\').querySelector(\'.product-card__quickview\').click()">' +
          '<span class="btn__text">Add to Cart</span>' +
        '</button>'
      : '';

    return (
      '<div class="product-card product-card-style-standard' + cardClass + '">' +
        '<div class="product-card__wrapper h-full" data-product-handle="' + handle + '" data-product-id="' + productId + '">' +
          '<div class="product-card__image-wrapper' + (images.length <= 1 ? ' product-card__image-wrapper--main-only' : '') + ' bg-none">' +
            '<a href="' + onlineStoreUrl + '" aria-label="' + title + '" tabindex="-1">' +
              '<motion-element data-motion="zoom-out-sm" class="block">' + mainImageHtml + secondImageHtml + '</motion-element>' +
            '</a>' +
            '<flair-badges product-id="' + productId + '" layout="' + flairBadgesLayout + '"></flair-badges>' +
            '<button class="product-card__quickview btn btn--icon-circle btn--white no-js-hidden"' +
              ' aria-label="' + quickViewAriaLabel + '" aria-controls="' + quickViewId + '" aria-haspopup="dialog">' +
              '<span class="btn__text flex gap-1 items-center">' +
                '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-search icon--large icon--thick" viewBox="0 0 24 24" fill="none">' +
                  '<path d="M10.875 18.75C15.2242 18.75 18.75 15.2242 18.75 10.875C18.75 6.52576 15.2242 3 10.875 3C6.52576 3 3 6.52576 3 10.875C3 15.2242 6.52576 18.75 10.875 18.75Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
                  '<path d="M16.4434 16.4453L20.9997 21.0016" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
                '</svg>' +
              '</span>' +
            '</button>' +
          '</div>' +
          '<div class="product-card__info">' +
            vendorHtml + siblingHtml +
            '<h3 class="product-card__title text-pcard-title">' +
              '<a class="reversed-link block" href="' + onlineStoreUrl + '"><span class="reversed-link__text">' + title + '</span></a>' +
            '</h3>' +
            priceHtml +
          '</div>' +
          addToCartHtml +
        '</div>' +
        '<quick-view-modal id="' + quickViewId + '" class="quick-view drawer--loading drawer drawer--right" data-product-url="' + onlineStoreUrl + '" hidden>' +
          '<div class="fixed-overlay" aria-controls="' + quickViewId + '"></div>' +
          '<div class="drawer__inner flex flex-col color-' + overlayColorScheme + '">' +
            '<div class="drawer__header-title md:hidden"><h3>Quick view</h3></div>' +
            '<button class="drawer__close-btn z-2" aria-controls="' + quickViewId + '" aria-label="Close">' +
              '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">' +
                '<path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />' +
              '</svg>' +
            '</button>' +
            '<div class="loading__spinner drawer__loading-spinner">' +
              '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
                '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
              '</svg>' +
            '</div>' +
            '<div class="drawer__body v-scrollable h-full quick-view__content"></div>' +
          '</div>' +
        '</quick-view-modal>' +
      '</div>'
    );
  };
})();
